/*
  Appstle's product-page widget is a theme app block that renders OUTSIDE Dawn's product <form>, so
  its selling_plan radios never reach FormData(form) in product-form.js. Picking "Subscribe" added a
  one-time purchase at the full price, from the main button and from the sticky bar, on phone and
  desktop (verified with real clicks 2026-09-15; Henry: "it keeps switching off").

  Mirror the chosen plan into a hidden selling_plan field inside every add-to-cart form on the
  product page. One-time purchase = the field is disabled, so nothing is sent.
*/
(function () {
  var WIDGET = '[id$="__appstle_subscription"]';

  function chosenPlan() {
    var fields = document.querySelectorAll(WIDGET + ' [name="selling_plan"]');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (f.type === 'radio' ? f.checked : true) return f.value || '';
    }
    return '';
  }

  // Only the product section that holds the widget: its own form and its sticky bar. The cart drawer upsell and
  // quick-add cards are product forms too, and with items in the cart they come first in the page.
  function targetForms() {
    var widget = document.querySelector('#MainContent ' + WIDGET) || document.querySelector(WIDGET);
    var section = widget && widget.closest('[id^="shopify-section-"]');
    if (!section) return [];
    var id = section.id.replace('shopify-section-', '');
    return [document.getElementById('product-form-' + id), document.getElementById('RkStickyForm-' + id)].filter(Boolean);
  }

  function sync() {
    var plan = chosenPlan();
    targetForms().forEach(function (form) {
      var hidden = form.querySelector('input[data-rk-selling-plan]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'selling_plan';
        hidden.setAttribute('data-rk-selling-plan', '');
        form.appendChild(hidden);
      }
      hidden.value = plan;
      hidden.disabled = !plan;
    });
  }

  // Capture phase: runs before product-form.js reads the form on submit, and after any widget change.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest(WIDGET)) sync();
  }, true);
  document.addEventListener('submit', function (e) {
    if (targetForms().indexOf(e.target) !== -1) sync();
  }, true);
  sync();
})();
